import { useMutation } from "react-query";
import { generateECommConsentForm } from "api/customers";

// Custom hook to generate electronic communications consent form
const useGenerateECommConsentForm = (clientId) => {
  return useMutation(() => generateECommConsentForm(clientId));
};

export default useGenerateECommConsentForm;
